module.exports = __webpack_public_path__ + "static/img/03.126e893.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news21/03.png
// module id = Ip+9
// module chunks = 1